<template>
  <main
    class="pattern-sheet flex h-screen w-screen justify-center overflow-auto"
  >
    <div class="my-auto flex flex-col items-center justify-center p-4">
      <slot />
    </div>
  </main>
</template>
